import script from "./esHealthProSlugSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./esHealthProSlugSettings.vue?vue&type=script&setup=true&lang=ts"

import "./esHealthProSlugSettings.vue?vue&type=style&index=0&id=32aaaf88&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32aaaf88"]])

export default __exports__